import { render } from "./RegisterSuccessfull.vue?vue&type=template&id=750253cc&scoped=true&ts=true"
import script from "./RegisterSuccessfull.vue?vue&type=script&lang=ts"
export * from "./RegisterSuccessfull.vue?vue&type=script&lang=ts"

import "./RegisterSuccessfull.vue?vue&type=style&index=0&id=750253cc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750253cc"]])

export default __exports__